import axios from '@/util/axios'
import { NEW_API_CONFIG } from '@/util/constants'
import store from '@/store'
import { handleApiError as handleError } from '@/util/axios_common'

/**
 * 先例・判例書籍取得API
 * @param  {} params={}
 */
export const getBook = (params = {}) => {
  const token = store.state.auth.token
  const organizationId = store.state.profile.organization_id

  const r = {
    ...params,
    token: token,
    organization_id: organizationId
  }

  const newAxios = axios.create(NEW_API_CONFIG)
  return newAxios.post('/PJ/001', r).catch(handleError)
}

/**
 * 先例・判例目次取得API
 * @param  {} params={}
 */
export const getTOC = (params = {}) => {
  const token = store.state.auth.token
  const organizationId = store.state.profile.organization_id

  const r = {
    ...params,
    token: token,
    organization_id: organizationId
  }

  const newAxios = axios.create(NEW_API_CONFIG)
  return newAxios.post('/PJ/002', r).catch(handleError)
}

/**
 * 先例・判例検索API
 * @param  {} params={}
 */
export const search = (params = {}) => {
  const token = store.state.auth.token
  const organizationId = store.state.profile.organization_id

  const r = {
    ...params,
    token: token,
    organization_id: organizationId
  }

  const newAxios = axios.create(NEW_API_CONFIG)
  return newAxios.post('/PJ/003', r).catch(handleError)
}

/**
 * 先例・判例詳細API
 * @param  {} params={}
 */
export const detail = (params = {}) => {
  const token = store.state.auth.token
  const organizationId = store.state.profile.organization_id

  const r = {
    ...params,
    token: token,
    organization_id: organizationId
  }

  const newAxios = axios.create(NEW_API_CONFIG)
  return newAxios.post('/PJ/004', r).catch(handleError)
}

/**
 * 先例・判例検索数API
 * @param  {} params={}
 */
export const searchCount = (params = {}) => {
  const token = store.state.auth.token
  const organizationId = store.state.profile.organization_id
  
  const r = {
    ...params,
    token: token,
    organization_id: organizationId
  }

  const newAxios = axios.create(NEW_API_CONFIG)
  return newAxios.post('/PJ/005', r).catch(handleError)
}
